import React from 'react';
import { Label, Wrapper } from './SheetSelector.styles';
import { ApSimpleDropdown } from '@alixpartners/ui-components';

const SheetSelector = ({
	selectedFile,
	setSelectedSheet,
	sheetOption,
	setSheetOption,
}) => {
	const onSheetSelectionHandler = value => {
		const sheet = selectedFile?.sheets.find(
			sheet => sheet.sheetName === value.value
		);
		setSheetOption(value);
		setSelectedSheet(sheet);
	};

	return (
		<Wrapper>
			<Label>Select Sheet:</Label>
			<ApSimpleDropdown
				onChange={onSheetSelectionHandler}
				options={selectedFile?.sheets?.map(sheet => {
					return { label: sheet?.sheetName, value: sheet?.sheetName };
				})}
				selected={sheetOption}
			/>
		</Wrapper>
	);
};

export default SheetSelector;
